import styled from 'styled-components';

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  padding-left: 20px;
  padding-right: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 50px auto;
  display: block;
  overflow-x: auto;
  white-space: nowrap;
  font-weight: 700;
`;

const THead = styled.thead`
  width: 100%;
`;

const TR = styled.tr`
  &:nth-of-type(odd) {
    background: #eee;
  }
  &:hover {
    background-color: #e1e4e8;
  }
`;

const TH = styled.th`
  background: #3498db;
  color: white;
  font-weight: bold;
  font-size: 16px;
  padding: 10px;
  text-align: center;
  width: ${({ col, width }) =>
    width ? width : col ? Math.floor(window.screen.availWidth / col) : 30}px;
`;

const TD = styled.td`
  font-size: 16px;
  padding: 10px;
  text-align: center;
  font-size: 14px;
  width: ${({ col, width }) =>
    width ? width : col ? Math.floor(window.screen.availWidth / col) : 30}px;
`;

export { TableWrapper, Table, THead, TR, TH, TD };
